import api from './authService';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const vendorInvoiceApi = {
  getOne: async (id) => {
    const response = await api.get(`/vendor/invoices/${id}`);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await api.put(`/vendor/invoices/${id}`, payload);
    return response.data;
  },
  getBillableClients: async () => {
    const response = await api.get('/vendor/invoices/billable-clients');
    return response.data;
  },
  getBookingOptions: async (clientId) => {
    const response = await api.get('/vendor/invoices/booking-options', {
      params: clientId ? { client_id: clientId } : {},
    });
    return response.data;
  },
  createCustom: async (payload) => {
    const response = await api.post('/vendor/invoices/custom', payload);
    return response.data;
  },
  createFromBooking: async (bookingId, payload = {}) => {
    const response = await api.post(`/vendor/invoices/from-booking/${bookingId}`, payload);
    return response.data;
  },
  sendEmail: async (id, payload = {}) => {
    const response = await api.post(`/vendor/invoices/${id}/send-email`, payload);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/vendor/invoices/${id}`);
    return response.data;
  },
};

export const useDeleteVendorInvoice = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => vendorInvoiceApi.remove(id),
    onSuccess: (data, variables, ...rest) => {
      queryClient.invalidateQueries({ queryKey: ['vendorInvoices'] });
      queryClient.invalidateQueries({ queryKey: ['vendor-invoice'] });
      options.onSuccess?.(data, variables, ...rest);
    },
    onError: options.onError,
  });
};

export const useCreateInvoiceFromBooking = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingId, payload }) =>
      vendorInvoiceApi.createFromBooking(bookingId, payload),
    onSuccess: (data, variables, ...rest) => {
      queryClient.invalidateQueries({ queryKey: ['vendor-invoices'] });
      if (variables?.bookingId) {
        queryClient.invalidateQueries({ queryKey: ['vendorBooking', variables.bookingId] });
        queryClient.invalidateQueries({ queryKey: ['vendor-booking', variables.bookingId] });
        queryClient.invalidateQueries({ queryKey: ['booking', variables.bookingId] });
      }
      queryClient.invalidateQueries({ queryKey: ['vendorBookings'] });
      queryClient.invalidateQueries({ queryKey: ['bookings'] });
      options.onSuccess?.(data, variables, ...rest);
    },
    onError: options.onError,
  });
};
